import ky from 'ky'
import { httpError } from '../utils/errors'

/**
 * CallsService provides Call Log API services
 */
class CallsService {

    getForAccount = (accountId, offset= 0, length= 10, order='startTime,desc', search= '') => {

        /*
        console.warn('Faked call data incoming!')
        const fakeCalls = {
            calls: [
                {
                    sid: 'b33f366c-e060-45d4-bd21-c6a81e86317c',
                    to: '+61770101234',
                    from: '+61355502479',
                    direction: 'inbound',
                    status: 'answered',
                    startTime: '2021-07-05 02:37:13',
                    endTime: '2021-07-05 02:41:44',
                    duration: 271,
                },
                {
                    sid: 'c5a56bec-af9e-4877-abb9-c5a2f193b5b4',
                    to: '+61770101234',
                    from: '+61355502479',
                    direction: 'inbound',
                    status: 'answered',
                    startTime: '2021-07-04 02:32:12',
                    endTime: '2021-07-04 02:32:28',
                    duration: 16,

                },
                {
                    sid: '75ca4963-3b2f-4981-9069-40de7d9eca93',
                    to: '+61770101234',
                    from: '+61491573087',
                    direction: 'inbound',
                    status: 'noanswer',
                    startTime: '2021-07-03 05:31:50',
                    endTime: '2021-07-03 05:31:50',
                    duration: 0,

                }
            ],
            total: 120,
            filtered: 100
        }
        */

        let url = `/api/v2/accounts/${accountId}/calls` +
            `?offset=${offset}&length=${length}&order=${encodeURI(order)}&search=${encodeURI(search)}`;

        return new Promise((resolve, reject) => {
            // Get the account data, transforming any errors into a standardised error object
            ky.get(url).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }
}

// Create a singleton instance of the service to export
const instance = new CallsService();

export default instance;